import script from "./TradePassportProfileHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./TradePassportProfileHeader.vue?vue&type=script&setup=true&lang=ts"

import "./TradePassportProfileHeader.vue?vue&type=style&index=0&id=233ace41&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-233ace41"]])

export default __exports__